/** Parse "14:30", "2:30 PM", "02:30 pm", etc. into total minutes from midnight. */
export function timeToMinutes(time) {
  if (!time || typeof time !== "string") return null;

  const trimmed = time.trim();
  const match12 = trimmed.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (match12) {
    let hour = Number(match12[1]);
    const minute = Number(match12[2]);
    const period = match12[3].toUpperCase();
    if (hour < 1 || hour > 12 || minute > 59) return null;
    if (period === "AM") {
      hour = hour === 12 ? 0 : hour;
    } else {
      hour = hour === 12 ? 12 : hour + 12;
    }
    return hour * 60 + minute;
  }

  const match24 = trimmed.match(/^(\d{1,2}):(\d{2})$/);
  if (match24) {
    const hour = Number(match24[1]);
    const minute = Number(match24[2]);
    if (hour > 23 || minute > 59) return null;
    return hour * 60 + minute;
  }

  return null;
}

/** Convert a stored time string to 12h display format, e.g. "02:30 PM". */
export function formatTime12h(time) {
  const minutes = timeToMinutes(time);
  if (minutes === null) return time || "N/A";

  const hour24 = Math.floor(minutes / 60);
  const minute = minutes % 60;
  const period = hour24 >= 12 ? "PM" : "AM";
  let hour12 = hour24 % 12;
  if (hour12 === 0) hour12 = 12;

  return `${String(hour12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
}

/** Split a stored time into form parts: { hour: "01"-"12", minute: "00"-"59", period: "AM"|"PM" }. */
export function parseTimeParts(time) {
  const minutes = timeToMinutes(time);
  if (minutes === null) {
    return { hour: "", minute: "", period: "AM" };
  }

  const hour24 = Math.floor(minutes / 60);
  const minute = minutes % 60;
  const period = hour24 >= 12 ? "PM" : "AM";
  let hour12 = hour24 % 12;
  if (hour12 === 0) hour12 = 12;

  return {
    hour: String(hour12).padStart(2, "0"),
    minute: String(minute).padStart(2, "0"),
    period,
  };
}

/** Build a 12h time string from form parts. */
export function buildTime12h(hour, minute, period) {
  if (!hour || !minute || !period) return "";
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${period}`;
}

export const HOURS_12 = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0"),
);

export const MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, "0"),
);
